import { defineComponent as _defineComponent } from 'vue'
import { computed, onActivated, onMounted, ref, watch, watchEffect } from 'vue';
import NModel from '@/component/NModel/NModel.vue';
import moment from 'moment';
import { getCustomerTags, deleteCustomerTags } from '@/api/operation/customer';
import { useRouter, useRoute } from '@/router';
import { useForm } from '@/util/useForm';
import { message } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerTag',
  setup(__props) {

const router = useRouter();
const form = useForm(); // 表单
const queryParams = ref<any>({}); // 搜索条件
const pagination = ref({
  current: 1,
  total: 1,
  limit: 10,
});
const total = ref<number>(); // 共计
const condition_visible = ref<boolean>(false); // 查看标签条件-侧边抽屉
const loading = ref<boolean>(false); // 表格加载
const isShowDelete = ref<boolean>(false); // 删除确认框
const isShowMoreDelete = ref<boolean>(false); // 批量删除确认框
const selectedRowKeys = ref<any[]>([]); // 选中
const register_count_sort = ref<string | undefined>(); // 排序
const dataSource = ref<any>([]);
const customer_count = ref<number>();
const drawer_data = ref<any>({
  tag_type: undefined,
  tag_name: undefined,
  last_consumption_days: undefined,
  consumption_amount_range: [],
  order_avg_price_range: [],
  order_count_range: [],
});
const deleteId = ref<number[]>([]);
const isAllSelected = ref<boolean>(false); // 全选
// 全选框
function onSelectAllRows(e) {
  isAllSelected.value = e.target.checked;
  if (isAllSelected.value) {
    selectedRowKeys.value = dataSource.value?.map(item => item.id);
  } else {
    selectedRowKeys.value = [];
  }
}
// 查询
async function queryTabs() {
  const { type, name } = form.value.getFormValue();
  queryParams.value = {
    type,
    name,
  };
  query({
    current: pagination.value.current,
    limit: pagination.value.limit,
    ...queryParams.value,
  });
}
async function query(params = queryParams.value) {
  const formatParams = {
    current: pagination.value.current,
    limit: pagination.value.limit,
    ...params,
  };
  loading.value = true;
  dataSource.value = [];
  const res: any = await getCustomerTags(formatParams);
  loading.value = false;
  dataSource.value = res?.data.detail;
  total.value = res.data.total;
}
query();

// 清除搜索条件
function clear() {
  form.value.resetFields();
  queryParams.value = {};
  selectedRowKeys.value = [];
  isAllSelected.value = false;
  queryTabs();
}
// 新建
function addTag() {
  router.push('/customer/add-customer-tag');
}
// 删除
function deleteTag(record) {
  isShowDelete.value = true;
  customer_count.value = record.register_count;
  deleteId.value = [record.id];
}
// 确认删除
async function deleteOk() {
  const send_data = {
    id: deleteId.value,
  };
  const res = await deleteCustomerTags(send_data);
  if (res?.status !== 200) {
    message.error((res as any).message);
    return;
  }
  message.success('删除成功');
  isShowDelete.value = false;
  query();
}
function deleteCancel() {
  isShowDelete.value = false;
}
// 批量操作-删除
async function handleMenuClick(e) {
  if (e.key == '1' && selectedRowKeys.value.length < 1) {
    message.error('请勾选标签');
    return;
  }
  isShowMoreDelete.value = true;
}
// 确认删除
async function deleteMoreOk() {
  const send_data = {
    id: selectedRowKeys.value,
  };
  const res = await deleteCustomerTags(send_data);
  if (res?.status !== 200) {
    message.error((res as any).message);
    return;
  }
  message.success('删除成功');
  isShowMoreDelete.value = false;
  query();
}
function deleteMoreCancel() {
  isShowMoreDelete.value = false;
}
// 表格变动时
function onTableChange({ current }: any, filters, sorter) {
  const sort: any = sorter.order; // 排序类型，正序/倒序/不排序
  if (sort == 'ascend') {
    register_count_sort.value = 'asc';
  } else if (sort == 'descend') {
    register_count_sort.value = 'desc';
  } else {
    register_count_sort.value = undefined;
  }
  query({ register_count_sort: register_count_sort.value, current });
}
function Format(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}
function onSelectChange(selectedRow) {
  selectedRowKeys.value = selectedRow;
  if (selectedRowKeys.value.length == dataSource.value.length) {
    isAllSelected.value = true;
  } else {
    isAllSelected.value = false;
  }
}
// 改变每页显示条目
function onShowSizeChange(current, pageSize) {
  pagination.value.limit = pageSize;
  query({ ...queryParams.value, current: 1 });
}
function onChangePage(page) {
  pagination.value.current = page;
  query({ ...queryParams.value, current: pagination.value.current, limit: pagination.value.limit });
  selectedRowKeys.value = [];
  isAllSelected.value = false;
}

function showConditionDrawer(record) {
  condition_visible.value = true;
  drawer_data.value.tag_name = record.name;
  drawer_data.value.tag_type = record.type;
  drawer_data.value.last_consumption_days = record.rule.last_consumption_days;
  drawer_data.value.consumption_amount_range = record.rule.consumption_amount_range;
  drawer_data.value.order_avg_price_range = record.rule.order_avg_price_range;
  drawer_data.value.order_count_range = record.rule.order_count_range;
}
// 关闭抽屉
function onCloseDrawer() {
  condition_visible.value = false;
}
onActivated(() => {
  query();
});

return { __sfc: true,router, form, queryParams, pagination, total, condition_visible, loading, isShowDelete, isShowMoreDelete, selectedRowKeys, register_count_sort, dataSource, customer_count, drawer_data, deleteId, isAllSelected, onSelectAllRows, queryTabs, query, clear, addTag, deleteTag, deleteOk, deleteCancel, handleMenuClick, deleteMoreOk, deleteMoreCancel, onTableChange, Format, onSelectChange, onShowSizeChange, onChangePage, showConditionDrawer, onCloseDrawer, NModel }
}

})